export default __webpack_public_path__ + "static/media/1.5bc5d64a.jpg";